module.exports = __webpack_public_path__ + "static/img/protein02.77a5893.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/protein02.png
// module id = P8vI
// module chunks = 0